export enum SpecialDropType {
  DAILY_TASK = 'DAILY_TASK',
  SPIN_BANNER = 'SPIN_BANNER',
}

export interface SpecialDropModel {
  id: string;
  chanceToWin: number;
  rollCount: number;
  type: SpecialDropType;
  rewardsData: Record<string, boolean>;
  rewardIds: string[];
}

export type SpecialDropRequest = Pick<SpecialDropModel, 'chanceToWin' | 'type' | 'rewardIds'>;
